import React, { FC } from 'react';
import { BodyText } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { HeadshotsInfoModal } from './HeadshotsInfoModal';
import { UseHeadshotTrialModalValues } from './useHeadshotTrialModal';

export type HeadshotsTrialModalProps = {
  trialEndDate: UseHeadshotTrialModalValues['trialEndDate'];
  onUpgrade: UseHeadshotTrialModalValues['handleTrialUpgrade'];
  onClose: UseHeadshotTrialModalValues['closeTrialModal'];
};

/**
 * Trial upsell shown when an annual or monthly subscriber still inside their
 * paid trial opens Headshots. Copy only — eligibility, formatting, and the
 * upgrade flow live in `useHeadshotTrialModal`.
 */
export const HeadshotsTrialModal: FC<HeadshotsTrialModalProps> = ({ trialEndDate, onUpgrade, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeadshotsInfoModal
      title={t('talent:headshots.trialModal.title')}
      body={
        <Trans
          i18nKey="talent:headshots.trialModal.body"
          values={{ trialEndDate }}
          components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
        />
      }
      benefits={[
        {
          id: 'annual',
          label: (
            <Trans
              i18nKey="talent:headshots.trialModal.annualBenefit"
              components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
            />
          ),
        },
        {
          id: 'monthly',
          label: (
            <Trans
              i18nKey="talent:headshots.trialModal.monthlyBenefit"
              components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
            />
          ),
        },
      ]}
      prompt={t('talent:headshots.trialModal.prompt')}
      primaryActionLabel={t('talent:headshots.trialModal.upgradeNow')}
      onPrimaryAction={onUpgrade}
      secondaryActionLabel={t('talent:headshots.trialModal.maybeLater')}
      onSecondaryAction={onClose}
      closeLabel={t('common:button.close')}
      onClose={onClose}
    />
  );
};

export default HeadshotsTrialModal;
